import { render } from "./SickPay.vue?vue&type=template&id=fb2736ec&scoped=true"
import script from "./SickPay.vue?vue&type=script&lang=js"
export * from "./SickPay.vue?vue&type=script&lang=js"

import "./SickPay.vue?vue&type=style&index=0&id=fb2736ec&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2736ec"]])

export default __exports__